import ApiConnector from "@/repository/connector";

class Activity {
  create = async ({ id, activity }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/${id}/activity/`, { activity });
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  startFailure = async ({ id, activity }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/${id}/activity/${activity}/start-failure/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  finishFailure = async ({id,  activity }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/${id}/activity/${activity}/finish-failure/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Activity()